import React, { memo } from 'react';
import { Box } from '@betty/moonlight';
import {
  useTracker as useCommunityJackpotTracker,
  CommunityJackpotTracker,
} from '@betty/community-jackpot';
import { StatusHeaderItem } from '@betty/status';
import { LevelHeaderItem } from '@betty/levels';
import { CoinBalanceHeaderItem } from '@betty/wallet';
import { QuestsInGameHeaderItem } from '@betty/quests';
import { useParams } from 'react-router';

function GameHeader() {
  const { id: gameId, currencyCode } = useParams();
  const { visible: communityJackpotTrackerVisible, onMilestoneHit } =
    useCommunityJackpotTracker();

  return (
    <Box
      position="relative"
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
      gap="space-200"
      padding="space-100"
      paddingTop="space-0"
    >
      {currencyCode ? null : (
        <Box flex={1} flexDirection="row" gap="space-100">
          {communityJackpotTrackerVisible ? (
            <CommunityJackpotTracker onMilestoneHit={onMilestoneHit} />
          ) : (
            <LevelHeaderItem flex={1} />
          )}
          <StatusHeaderItem flex={3} />
          <CoinBalanceHeaderItem />
          <QuestsInGameHeaderItem gameId={Number(gameId)} />
        </Box>
      )}
    </Box>
  );
}

export default memo(GameHeader);
